import gql from 'graphql-tag';
import { PAGINATION_VIEW_MODEL_FRAGMENT } from 'shared';

export const GET_CREDIT_SUBMISSION_CHANGELOG = gql`
  ${PAGINATION_VIEW_MODEL_FRAGMENT}
  query CreditSubmissionChangelog($input: CreditSubmissionChangelogInput!) {
    result: creditSubmissionChangelog(input: $input) {
      error
      success

      pagination {
        ...PaginationMetaViewModel
      }

      items {
        id
        changes
        parentId
        changeType
        createdDateTime
        modifiedBy {
          id
          fullName
          account {
            id
            portalType
          }
        }
      }
    }
  }
`;
